<app-modal-devoluciones #novedadIndividual></app-modal-devoluciones>
<div class="container mt-5 ml-3">
    <div class="col-md-12 d-flex align-items-center">
        <h1 style="color: green">Carga y consulta de novedades</h1>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>
    <div class="col-md-12 d-flex align-items-center">
        <h2 style="color: black; font-weight: bold">
            Registro de devoluciones
        </h2>
    </div>
    <div class="row mt-3">
        <div class="col-md-4">
            <div class="card">
                <div class="card-body fondo-hover">
                    <h5 class="card-title card-titulo-negrita">
                        Novedades por carga masiva
                    </h5>
                    <p class="card-text"></p>
                    <p class="card-text">
                        {{ 'novedad.cuerpoCargaMasiva' | translate }}
                    </p>
                    <div class="card-text container_btn-reporte">
                        <a
                            class="btn btn-primary btn_color"
                            (click)="downloadReport()">
                            Descargar plantilla
                        </a>
                        <a
                            class="btn btn-primary btn_color"
                            (click)="openMassUploadModal(modalLoadReportDev)">
                            Carga masiva
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card">
                <div class="card-body fondo-hover">
                    <h5 class="card-title card-titulo-negrita">
                        Consulta cargues históricos
                    </h5>
                    <p class="card-text">
                        {{ 'novedad.textoCargueHistorico' | translate }}
                    </p>
                    <p class="card-text">
                        <a [routerLink]="['/novedad-filtro-fecha']">
                            Consulta novedades
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container mt-5 second-container">
    <h2 style="color: black; font-weight: bold">
        Consultar novedades y certificados de la empresa:
        {{ empresaSeleccionada }}
    </h2>

    <ul class="nav nav-tabs mt-3">
        <li class="nav-item">
            <a
                class="nav-link active"
                id="tabNovedades"
                data-bs-toggle="tab"
                href="#novedades">
                Novedades
            </a>
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                id="tabCertificados"
                data-bs-toggle="tab"
                href="#certificados"
                (click)="showCertificates()">
                Certificados
            </a>
        </li>
    </ul>

    <div class="tab-content mt-3">
        <div class="tab-pane fade show active" id="novedades">
            <div class="container mt-3">
                <div class="row">
                    <div class="col-md-3">
                        <label for="selectSemestre">Semestre:</label>
                        <select
                            class="form-select"
                            id="selectSemestre"
                            [(ngModel)]="selectedSemester"
                            (change)="historyReportDev()">
                            <option
                                *ngFor="let semester of semester"
                                [value]="semester.value">
                                {{ semester.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label for="selectAnio">Año:</label>
                        <select
                            class="form-select"
                            id="selectAnio"
                            [(ngModel)]="selectedYear"
                            (change)="historyReportDev()">
                            <option *ngFor="let year of years" [value]="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>

                    <table class="table mt-3">
                        <thead>
                            <tr>
                                <th>Año</th>
                                <th>Semestre</th>
                                <th>Fecha de carga</th>
                                <th>Autor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="lastReportDev">
                                <td>{{ lastReportDev.anio }}</td>
                                <td>{{ lastReportDev.semestreNombre }}</td>
                                <td>{{ lastReportDev.fechaInicio }}</td>
                                <td>{{ lastReportDev.nombreRepresentante }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            [class]="
                showCertificados ? 'tab-pane fade show active' : 'tab-pane fade'
            "
            id="certificados">
            <table class="table mt-3">
                <thead>
                    <tr>
                        <th>Año</th>
                        <th>Semestre</th>
                        <th>Fecha de novedad</th>
                        <th>Descarga</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="lastReportDev">
                        <td>{{ lastReportDev.anio }}</td>
                        <td>{{ lastReportDev.semestreNombre }}</td>
                        <td>{{ lastReportDev.fechaInicio }}</td>
                        <td>
                            <button
                                class="btn btn-primary"
                                (click)="descargarCertificado()">
                                <i class="bi bi-download"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #modalLoadReportDev>
    <div class="modal-content">
        <div class="modal-header border-0">
            <h5 class="modal-title">Carga masiva devoluciones</h5>
            <button
                type="button"
                class="close"
                (click)="closeMassUploadModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div
            class="modal-body border-0 d-flex align-items-center justify-content-center">
            <div class="row">
                <div class="col title-file">
                    <p>{{ 'novedad.textoModalCargaMasiva' | translate }}</p>
                </div>
                <div
                    class="row container-file"
                    style="border: 1px dashed #ccc; padding: 10px">
                    <label for="fileInput" style="width: 100%; cursor: pointer">
                        <div class="col" *ngIf="!selectedFile">
                            <div class="container text-center">
                                <h5>Carga el archivo</h5>
                                <p class="text-muted">.xlsx- Max 2 Mb</p>
                                <input
                                    type="file"
                                    id="fileInput"
                                    style="display: none"
                                    (change)="onFileSelected($event)" />
                            </div>
                        </div>
                    </label>
                    <div class="col text-center">
                        <div
                            *ngIf="selectedFile && !filesend && !fileUploaded"
                            class="text-center">
                            <p>{{ selectedFile.name }}</p>
                            <p>{{ getFileSize(selectedFile.size) }}</p>
                        </div>
                        <div
                            *ngIf="filesend && !fileUploaded"
                            class="text-center">
                            <p>
                                <i class="fas fa-check-circle"></i>
                                Archivo enviado!
                            </p>
                        </div>
                        <div *ngIf="fileUploaded" class="text-center">
                            <p>¿ Desea reemplazar la novedad anterior?</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer border-0 justify-content-center">
            <button
                type="button"
                class="btn btn-success"
                (click)="saveMassUpload()"
                [disabled]="fileUploaded || filesend">
                {{ fileUploaded ? 'Cargando...' : 'Guardar' }}
            </button>
            <button
                *ngIf="fileUploaded"
                type="button"
                class="btn btn-warning"
                (click)="replaceFile()">
                Reemplazar
            </button>
        </div>
    </div>
</ng-template>
